import styled, { css } from 'styled-components';

import {
    mediaMixin,
    spaceMixin,
    Spacer,
    Text,
    token,
} from '@zillow/constellation';
import { Tag } from '@zillow/zrs-comet';

import MediumIllustrationHouse1x from 'app/shared/images/MediumIllustrationHouse@1x.png';
import MediumIllustrationHouse2x from 'app/shared/images/MediumIllustrationHouse@2x.png';

const LISTED_FOR_RENT = 'LISTED FOR RENT';

export const StyledContainer = styled.div`
    ${props => (props.isSelectable ? 'cursor: pointer;' : '')}
    background: ${token('colors.white')};
    border-bottom: 1px solid ${token('colors.gray300')};

    &:last-child {
        border-bottom: none;
    }
`;

export const StyledContentContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: ${spaceMixin('xs')} 0px;
    text-align: left;

    ${mediaMixin('lg', css`
        flex-direction: row;
        padding: ${spaceMixin('sm')} ${spaceMixin('xs')};
    `)};
`;

const StyledSmallText = css`
    font-size: 14px;
    line-height: 18px;

    ${mediaMixin('lg', css`
        line-height: 24px;
    `)};
`;

export const StyledStreetText = styled(Text)`
    && {
        font-size: 20px;
        font-weight: 700;
        line-height: 26px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        ${mediaMixin('lg', css`
            max-width: 500px;
        `)}
    }
`;

export const StyledCityStateText = styled(Text)`
    && {
        ${StyledSmallText}
        font-weight: 700;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        ${mediaMixin('lg', css`
            max-width: 500px;
        `)}
    }
`;

export const StyledSourceDetails = styled.div`
    display: flex;
    flex-direction: column;
    margin: 4px 0px;

    ${mediaMixin('lg', css`
        flex-direction: row;
    `)}
`;


export const StyledFeedSource = styled.div`
    ${StyledSmallText}
    font-weight: 700;

    ${mediaMixin('lg', css`
        &::after {
            content: " \\2022";
        }
    `)}
`;

export const StyledEmail = styled.div`
    ${StyledSmallText}
    font-weight: ${({ bold }) => (bold ? '700' : 'normal')};
    max-width: 100%;

    ${mediaMixin('lg', css`
        &:before {
            content: "\\00a0 ";
        }

        &::after {
            content: " \\2022";
        }
    `)}
`;

export const StyledPhone = styled.div`
    ${StyledSmallText}
    font-weight: ${({ bold }) => (bold ? '700' : 'normal')};

    ${mediaMixin('lg', css`
        &:before {
            content: "\\00a0 ";
        }
    `)}
`;

export const PhotoContainer = styled.div`
    background-color: ${token('colors.aqua500')};
    background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse2x)});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: ${props => (props.primaryPhotoUrl ? 'cover' : '200px')};
    border-radius: 4px;
    height: 168px;
    margin-bottom: ${spaceMixin('xs')};
    width: 100%;

    ${mediaMixin('lg', css`
        background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse1x)});
        background-size: ${props => (props.primaryPhotoUrl ? 'cover' : '105px')};
        height: 124px;
        margin-bottom: 0px;
        margin-right: ${spaceMixin('md')};
        width: 124px;
    `)}
`;

export const StyledMobileStatusTag = styled(Tag)`
    background-color: ${({ status }) => (status === LISTED_FOR_RENT ? token('colors.purple600') : '')};
    border-radius: 10px;
    color: ${({ status }) => (status === LISTED_FOR_RENT ? token('colors.white') : '')};
    display: inline-block;
`;

export const StyledMobileStatusSpacer = styled(Spacer)`
    ${mediaMixin('lg', css`
       display: none;
    `)}
`;

export const StyledDesktopStatusSpacer = styled(Spacer)`
    display: none;

    ${mediaMixin('lg', css`
       display: block;
    `)}
`;

export const StyledFlexWithMobileMargin = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-left: ${({ isSelectable }) => (isSelectable ? '30px' : '0px')};
    min-width: 0;

    ${mediaMixin('lg', css`
        margin-left: 0px;
    `)}
`;
